import { useState, useEffect } from 'react';
import { AirportStatus, FogStatusCalculator } from '../../services/FogStatusCalculator';
import { HourlyForecastTimelineData } from '../../models/HourlyForecastTimelineData';
import { NO_DATA_COLOR } from '../../theme/colors';
import { NZ_AIRPORTS_DATA } from '../../data/locations';

interface UseAirportStatusesProps {
  airportTimelineData: Record<number, HourlyForecastTimelineData>;
  dataAirports?: number[];
}

interface UseAirportStatusesResult {
  airportColors: Record<number, string>;
  airportStatuses: Record<number, AirportStatus>;
}

/**
 * Custom hook to process timeline data into airport status colors
 * Extracts the data processing logic from MapPage's useEffect
 */
export function useAirportStatuses({
  airportTimelineData
}: UseAirportStatusesProps): UseAirportStatusesResult {
  const [airportColors, setAirportColors] = useState<Record<number, string>>({});
  const [airportStatuses, setAirportStatuses] = useState<Record<number, AirportStatus>>({});

  useEffect(() => {
    // Initialize all airports with NO_DATA_COLOR
    const colors: Record<number, string> = {};
    const statuses: Record<number, AirportStatus> = {};

    NZ_AIRPORTS_DATA.forEach(airport => {
      colors[airport.id] = NO_DATA_COLOR;
      statuses[airport.id] = { actualColor: NO_DATA_COLOR, forecastColor: NO_DATA_COLOR };
    });

    // Process timeline data to determine colors and statuses
    Object.entries(airportTimelineData).forEach(([locationIdStr, timelineData]) => {
      const locationId = parseInt(locationIdStr);

      // Use FogStatusCalculator to determine status
      const status = FogStatusCalculator.calculateAirportStatuses(timelineData);

      console.log(`[useAirportStatuses] ${timelineData.location_name} (ID ${locationId}): forecastColor=${status.forecastColor}, actualColor=${status.actualColor}`);

      // For backward compatibility with old color display logic
      colors[locationId] = status.forecastColor;
      statuses[locationId] = status;
    });

    setAirportColors(colors);
    setAirportStatuses(statuses);
    console.log('useAirportStatuses updated - airport count:', Object.keys(airportTimelineData).length);
  }, [airportTimelineData]);

  return {
    airportColors,
    airportStatuses
  };
}